<template>
    <div>

        <div v-if="penaliteBascule && isOnShokz" class="text-left section_fiche_penalite">
            <v-icon name="exclamation-triangle" class="icon_penalite"></v-icon>
            Bascule - Pénalité 2h
        </div>
    </div>

</template>

<script>
export default {
    props: {
        runner: {
            type: Object,
            required: true
        }
    },
    computed: {
        penaliteBascule() {
            return this.runner.identite.penalite && this.runner.identite.penalite != '' && this.runner.identite.penalite == 'BASCULE';
        },
        isOnShokz() {
            return this.runner.identite.course == 'SHOKZ Demi tOur du lac d Annecy' || this.runner.identite.course == 'tOur du Lac en Solo en 2 jours';
        }
    }
}
</script>

<style lang="scss">
.section_fiche_penalite {
    background-color: #ffcd83;
    color: rgb(41, 41, 41);
    padding: 10px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 1.2rem;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon_penalite {
        color: rgb(41, 41, 41);
        margin-right: 10px;
    }
}
</style>